var React = require('react');

function NoteStream (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.176.5h17.648C19.473.5 20 1.027 20 1.676v.648c0 .65-.527 1.176-1.177 1.176H1.177C.526 3.5 0 2.973 0 2.324v-.648C0 1.026.527.5 1.176.5zm0 6h17.648c.65 0 1.176.527 1.176 1.176v.648c0 .65-.527 1.176-1.177 1.176H1.177C.526 9.5 0 8.973 0 8.324v-.648C0 7.026.527 6.5 1.176 6.5zm10.589 6H1.176C.526 12.5 0 13.027 0 13.677v.646c0 .65.527 1.177 1.176 1.177h10.589c.65 0 1.176-.527 1.176-1.177v-.646c0-.65-.527-1.177-1.176-1.177z","fill":"currentColor"}));
}

NoteStream.defaultProps = {"width":"20","height":"16","fill":"none"};

module.exports = NoteStream;

NoteStream.default = NoteStream;
